import { Nilable } from "@shared/utils";

export interface IPayloadAccionesDTO {
    tag_type_id?: Nilable<number>;
    tag_id?: Nilable<number>;
    campaign_id?: Nilable<number>;
    user_id?: Nilable<number>;
}

export class PayloadAccionesDTO {
    public tagTypeId: Nilable<number> = null;
    public tagId: Nilable<number> = null;
    public grupoId: Nilable<number> = null;
    public userId: Nilable<number> = null;

    constructor(json: Nilable<Partial<IPayloadAccionesDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IPayloadAccionesDTO>) {
        if (json.tag_type_id != null) {
            this.tagTypeId = json.tag_type_id;
        }
        if (json.tag_id != null) {
            this.tagId = json.tag_id;
        }
        if (json.campaign_id != null) {
            this.grupoId = json.campaign_id;
        }
        if (json.user_id != null) {
            this.userId = json.user_id;
        }
    }

    public toJSON(): IPayloadAccionesDTO {
        const json: Partial<IPayloadAccionesDTO> = {};
        if (this.tagTypeId != null) {
            json.tag_type_id = this.tagTypeId;
        }
        if (this.tagId != null) {
            json.tag_id = this.tagId;
        }
        if (this.grupoId != null) {
            json.campaign_id = this.grupoId;
        }
        if (this.userId != null) {
            json.user_id = this.userId;
        }
        return json;
    }
}
